import { render, staticRenderFns } from "./DemoPane.vue?vue&type=template&id=3fe2018c&scoped=true"
import script from "./DemoPane.vue?vue&type=script&lang=js"
export * from "./DemoPane.vue?vue&type=script&lang=js"
import style0 from "./DemoPane.vue?vue&type=style&index=0&id=3fe2018c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe2018c",
  null
  
)

export default component.exports